import { Combobox, Form } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import { REGISSEUR } from '@/constants';

type FormRegisseurProps = {
  loading?: boolean;
  mandat: number;
  actif: boolean;
  onChange: (name: string, value: any) => void;
};

const FormRegisseur = ({ loading, mandat, actif, onChange }: FormRegisseurProps) => {
  const handleMandatChange = React.useCallback(
    (e, { value }) => {
      if (onChange) {
        onChange('mandat', value);
      }
    },
    [onChange],
  );

  const handleActifChange = React.useCallback(
    (e, { checked }) => {
      if (onChange) {
        onChange('actif', checked);
      }
    },
    [onChange],
  );

  const optionsMandat = React.useMemo(
    () =>
      _.map(REGISSEUR.TYPES, (t, i) => ({
        key: `mandat${i}`,
        value: i,
        text: t,
      })),
    [],
  );

  return (
    <Form>
      <Form.Group>
        <Form.Field
          required
          // @ts-expect-error
          style={{ flex: 1 }}
        >
          <label>Type de régisseur ou mandataire</label>
          {/* @ts-expect-error */}
          <Combobox
            data-testid="form-regisseur-select-mandat"
            menuPortalTarget={document.body}
            selection
            name="mandat"
            value={mandat}
            options={optionsMandat}
            onChange={handleMandatChange}
            loading={loading}
            disabled={loading}
          />
        </Form.Field>
        <Form.Checkbox
          data-testid="form-regisseur-checkbox-actif"
          label="Actif"
          toggle
          defaultChecked
          onChange={handleActifChange}
          checked={actif}
        />
      </Form.Group>
    </Form>
  );
};

export default FormRegisseur;
